// extracted by mini-css-extract-plugin
module.exports = {"back":"RmG-4JsyE6mb6qxTxPHdRw=="};